module.exports = __webpack_public_path__ + "static/media/menu4.fc25126f.jpg";